import { cx } from '@/lib/cx';
import styles from './Avatar.module.css';

/** Avatar com iniciais (sem fotos na V1). `tone` dá cor de identidade sem depender dela. */
export function Avatar({
  initials,
  size = 28,
  tone = 'neutral',
  label,
  className,
}: {
  initials: string;
  size?: 20 | 28 | 32;
  tone?: 'neutral' | 'accent' | 'indigo' | 'teal' | 'orange' | 'pink';
  /** Nome completo para leitores de tela; sem ele o avatar é decorativo. */
  label?: string;
  className?: string;
}) {
  const text = initials.slice(0, 3).toUpperCase();
  return label ? (
    <span
      className={cx(styles.avatar, className)}
      data-size={size}
      data-tone={tone}
      role="img"
      aria-label={label}
      title={label}
    >
      {text}
    </span>
  ) : (
    <span className={cx(styles.avatar, className)} data-size={size} data-tone={tone} aria-hidden="true">
      {text}
    </span>
  );
}
